import React, { useContext } from "react";
import { ThemeContext } from "../../theme/ThemeProvider";
import Welcome from "../welcome/Welcome";
import FocusTo from "./FocusTo";
import HomeProjects from "./HomeProjects";
import HomeContact from "./HomeContact";
import Scrolltopbutton from "../../scrolltopbutton/Scrolltopbutton";
import BenevityPartner from "../../banevitypartner/BenevityPartner";
import OnlineClass from "../../../Trust/components/OnlineClass";
import Donation from "../../donation/Donation";
import { DonationDetails } from "../../admin/donationdetails/DonationDetails";
import BankAccounts from "./BankAccounts";
// import { OnlineClass } from "@11solutionspvtltd/eleven-solutions-trust-website";

const Home = () => {
  const themeContext = useContext(ThemeContext);
  if (!themeContext) {
    throw new Error("ThemeContext must be used within a ThemeProvider");
  }
  const { isDarkMode } = themeContext;

  return (
    <div
      className={`${
        isDarkMode
          ? "bg-globalBg border-b border-gray-700"
          : "bg-[#ffff] border-b border-gray-200"
      } `}
    >
      <Welcome />
      <FocusTo />
      <HomeProjects />
      <BankAccounts />
      <BenevityPartner />
      <HomeContact />
      <Scrolltopbutton />
    </div>
  );
};

export default Home;
